import React from 'react';
import { DateTime } from 'luxon';

import { CoachProfileModel } from 'app/models/scheduling/CoachProfileModel';
import { AvailableSlotModel } from 'app/models/scheduling/AvailableSlotModel';

import DayRow from './DayRow';

import styles from './DateTime.module.scss';
import { Loading } from 'app/components/Wrappers';

type PropsDef = {
  currentDay: DateTime;
  coach: CoachProfileModel;
  timeSlots: Record<string, AvailableSlotModel[]>;
  loading: boolean;
  submitForm: () => void;
  pricingValue?: CoachProfileModel['defaultLessonRate'];
};

const DaysPanel = ({
  currentDay,
  coach,
  timeSlots,
  loading,
  submitForm,
  pricingValue,
}: PropsDef) => {
  return (
    <div className={styles.days_panel_container}>
      {/* CFTB-3425: one wheel. A spinner used to sit at each end of the list, from
          when the panel scrolled infinitely in both directions and each end could
          be fetching. Both hang off the same `loading`, so once the panel showed a
          single day (#29 below) one fetch painted two wheels. It replaces the day
          rather than bracketing them: a spinner above and below the previous day's
          slots reads as though those slots belong to the day being opened. */}
      {loading ? (
        <div className={styles.days_panel_loading}>
          <Loading isLoading loadType="spinner" />
        </div>
      ) : (
        /* CN-2652 #29: one day at a time. The athlete moves between days with the
           calendar rather than scrolling through them ("we should get rid of the
           infinity scroll... display only a single day and they need to navigate
           through the calendar"). The window either side is still fetched, so
           moving day to day stays instant — it is simply not all rendered. */
        timeSlots && Object.entries(timeSlots)
          .filter(([date]) => date === currentDay.toISODate())
          .map(([date, slots]) => {
            const formattedDate = DateTime.fromISO(date);
            return (
              <DayRow
                coach={coach}
                day={formattedDate}
                current={currentDay.toISODate() === formattedDate.toISODate()}
                // The day is the only one on screen, so it needs neither the wash
                // that marked it among its neighbours nor its own date heading —
                // the date is already above the slots.
                singleDay
                timeSlots={slots}
                key={date}
                submitForm={submitForm}
                pricingValue={pricingValue}
              />
            );
        })
      )}
    </div>
  );
};

export default DaysPanel;
